class ProductGridContainer extends HTMLElement {
	constructor() {
		super()
		this.selectors = {
			container: '#ProductGridContainer',
			paginate: '[data-paginate]',
			btnLoadmore: '[data-load-more]',
			productGrid: '[data-products-grid]',
			columnSelector: '.column-switcher button',
			viewMoreSwatches: '[data-view-more-options]'
		}
	}

	connectedCallback() {
		this.init()
	}

	init() {
		this.container = this.closest(this.selectors.container)
		this.sectionId = this.dataset.sectionId
		this.collectionHandle = this.dataset.collectionHandle;
		this.loadedReturnToProduct = false;
		this.domNodes = queryDomNodes(this.selectors, this)
		this.infiniteLoadingObserver = null
		this.currentPage = 1
		this.save_key = 'foxtheme:grid-columns'

		this.initLoadMore()
		this.setupReturnToProductInCollection();
		this.columnSwitcher()
		this.initSwatches();
		// this.initViewMoreSwatches();
	}

	initLoadMore() {
		const {paginate} = this.domNodes
		if (!paginate) return
		this.paginateType = paginate.dataset.paginate
		this.totalPages = Number(paginate.dataset.totalPages)
		 
		// A/B Test for Collection pagination
		if ( window.collectionATTestCurrentlyRunning ) {
			if (window.collectionABTest) {
				const paginationContainer = document.querySelector('[data-test="test"]')
				if ( paginationContainer != null ) {
					paginationContainer.classList.remove('hidden')
				}
				this.paginateType = 'number'
			} else if (!window.collectionABTest ) {
				const infiniteContainer = document.querySelector('[data-test="control"]')
				if ( infiniteContainer != null ) {
					infiniteContainer.classList.remove('hidden')
				}
				this.paginateType = 'infinite'
			}
		}

		if (this.paginateType === 'number' || this.totalPages <= 1) return

		const { btnLoadmore } = this.domNodes
		addEventDelegate({
			selector: this.selectors.btnLoadmore,
			handler: e => {
				e.preventDefault()
				this.loadMoreProducts()
			}
		})

		if (this.paginateType === 'infinite') {
			this.infiniteLoadingObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.intersectionRatio === 1) { 
						// we dont want to double load a section if loadedReturnProduct has not finished yet
						if ( this.loadedReturnToProduct ) {
							this.loadMoreProducts() 
						}
					}
				});
			}, { threshold: 1 });

			this.infiniteLoadingObserver.observe(btnLoadmore)
		}
	}

	async setupReturnToProductInCollection() {

		// dont run if not infinite use same logic that initLoadMore uses
		// if we dont run, automatically set loaded flag
		const {paginate} = this.domNodes;
		if (!paginate) {
			this.loadedReturnToProduct = true;
			return
		};

		if (this.paginateType === 'number' || this.totalPages <= 1) { 
			this.loadedReturnToProduct = true;
			return
		};

		const currentCollectionStored = this.getCurrentCollection();
		if ( this.collectionHandle != currentCollectionStored ) {
			console.log( 'Collection changed! Setting collection, resetting page, and related button id' );
			this.saveCurrentCollection( this.collectionHandle );
			console.log('Collection is using loadmore button.  Set page to include products on next page.')
			if ( this.paginateType === 'loadmore' ) {
				let currentPage = 1;
				this.saveCurrentPage( currentPage );
				let loadMoreBtn = document.querySelector('btn-loadmore');
				if ( loadMoreBtn != null ) {
					loadMoreBtn.addEventListener('click', () => {
						currentPage++;
						this.saveCurrentPage( currentPage );
					})
				}
			} else {
				this.saveCurrentPage( 1 );
			}
			this.saveProductButtonIdToFocus( '' );
		} else {
			console.log( 'Collection is the same! Checking page and button to focus...' );
			const currentPageRef = this.getLocalStoragePage();
			const currentButtonIdRef = this.getLocalStorageButtonId();
			const currentPageAsInt = parseInt( currentPageRef );

			
			if ( currentButtonIdRef != '' && currentButtonIdRef != null ) {
				const pagesToLoad = currentPageAsInt - 1;
				console.log( `Page is above 1 and a button ref was set. Loading the next ${pagesToLoad} pages` );
				for ( let i = 0; i < pagesToLoad; i++ ) {
					await this.loadMoreProductsAsync();
				}

				if ( pagesToLoad == 0 ) {
					this.focusElement( currentButtonIdRef );
				}
			}
		}

		this.loadedReturnToProduct = true;
	}

	focusElement( selector ) {
		const elementToFocus = document.querySelector( selector );
		if ( elementToFocus ) {
			elementToFocus.focus();
			this.clearProductButtonIdToFocus();
		} else {
			console.log( `Element for selector ${selector} has not loaded yet.` );
		}

		return;
	}

	getLocalStoragePage() {
		const page = localStorage.getItem( "page_in_collection" );
		return page;
	}

	saveCurrentPage( p ) {
		localStorage.setItem( 'page_in_collection' , p );
		return;
	}

	getCurrentCollection() {
		const collection = localStorage.getItem( "current_collection" );
		return collection;
	}

	saveCurrentCollection( c ) {
		localStorage.setItem( 'current_collection' , c );
		return;
	}

	getLocalStorageButtonId() {
		const buttonId = localStorage.getItem( "button_to_scroll_to" );
		return buttonId;
	}

	saveProductButtonIdToFocus( b ) {
		localStorage.setItem( 'button_to_scroll_to' , b );
		return;
	}

	clearProductButtonIdToFocus() {
		localStorage.removeItem( 'button_to_scroll_to' );
	}

	loadMoreProducts() {
		const productGrid = document.querySelector(this.selectors.productGrid)
		const btnLoadmore = document.querySelector(this.selectors.btnLoadmore)
		const nextPage = this.currentPage + 1
		console.log( `[SYNC] attempting to load page ${nextPage} of ${this.totalPages}` );
		if (nextPage > this.totalPages) return

		this.toggleLoading(true, btnLoadmore)
		fetchSection(this.sectionId, { fromCache: true, params: { page: nextPage } })
			.then(html => {
				const productNodes = html.querySelectorAll('[data-products-grid] .f-column')
				productNodes.forEach(prodNode => productGrid.appendChild(prodNode))
				this.initSwatches();
			})
			.catch(err => console.error(`Failed to load more products.`, err))
			.finally(() => {
				this.toggleLoading(false, btnLoadmore)
				this.currentPage = nextPage
				if (nextPage >= this.totalPages) {
					btnLoadmore.parentNode.remove()
					if (this.infiniteLoadingObserver) {
						this.infiniteLoadingObserver.unobserve(btnLoadmore)
					}
				}
			})
	}

	async loadMoreProductsAsync() {
		const productGrid = document.querySelector(this.selectors.productGrid)
		const btnLoadmore = document.querySelector(this.selectors.btnLoadmore)
		const nextPage = this.currentPage + 1
		console.log( `[ASYNC] attempting to load page ${nextPage} of ${this.totalPages}` );
		if (nextPage > this.totalPages) return

		this.toggleLoading(true, btnLoadmore)

		try {
			const html = await fetchSection(this.sectionId, { fromCache: true, params: { page: nextPage } });
			const productNodes = html.querySelectorAll('[data-products-grid] .f-column')
			productNodes.forEach(prodNode => productGrid.appendChild(prodNode))
			this.initSwatches();
		} catch ( err ) {
			console.error(`Failed to load more products.`, err);
		} finally {
			this.toggleLoading(false, btnLoadmore)
			this.currentPage = nextPage
			this.saveCurrentPage( nextPage );
			if (nextPage >= this.totalPages) {
				btnLoadmore.parentNode.remove()
				if (this.infiniteLoadingObserver) {
					this.infiniteLoadingObserver.unobserve(btnLoadmore)
				}
			}

			//try focusing the element
			const buttonIdToFocus = this.getLocalStorageButtonId();
			if ( buttonIdToFocus != '' && buttonIdToFocus != null ) {
				this.focusElement( buttonIdToFocus );
			}
		}
	}

	toggleLoading(loading, btnLoadmore) {
		const pageTransitionDiv = document.querySelector(".f-page-transition")
		const enablePageTransition = window.enableInfLoadTransition

		if (btnLoadmore) {
			const method = loading ? 'add' : 'remove'
			btnLoadmore.classList[method]('btn--loading')

			if (pageTransitionDiv != null && enablePageTransition) {
				if (method === 'add') {
					pageTransitionDiv.classList.remove("fade-out")
					pageTransitionDiv.classList.add("fade-in")
				} else {
					pageTransitionDiv.classList.add("fade-out")
					pageTransitionDiv.classList.remove("fade-in")
				}
			}
		}
	}

	columnSwitcher() {
		const data = localStorage.getItem(this.save_key)
		if (!window.FoxThemeSettings.designMode && '1,2'.includes(data)) this.setColumn(data)

		addEventDelegate({
			selector: this.selectors.columnSelector,
			context: this,
			handler: (e, target) => {
				e.preventDefault()
				const {column} = target.dataset
				this.setColumn(column)
			}
		})

	}

	setColumn(column) {
		const productGrid = document.querySelector(this.selectors.productGrid)
		if (!productGrid) return
		const target = this.querySelector('.column-switcher button[data-column="'+ column +'"]')
		const selected = this.querySelector('.column-switcher button[aria-selected="true"]')
		if (selected) {
			selected.removeAttribute('aria-selected')
		}
		target.setAttribute('aria-selected', true)

		if (column === '2') {
			productGrid.classList.add('f-grid-2-cols');
			productGrid.classList.remove('f-grid-1-cols');
		} else {
			productGrid.classList.remove('f-grid-2-cols');
			productGrid.classList.add('f-grid-1-cols');
		}

		localStorage.setItem(this.save_key, column)
	}

	initSwatches() {
		// console.log( 'INIT SWATCHES' );
		const event = new CustomEvent("recommendationsLoaded", {} );
		document.dispatchEvent( event );

		return;
	}

	initViewMoreSwatches() {
		const buttons = document.querySelectorAll( this.selectors.viewMoreSwatches );
		for ( let i = 0; i < buttons.length; i++ ) {
			buttons[i].removeEventListener( 'click' , this.viewMoreSwatches );
			buttons[i].addEventListener( 'click' , this.viewMoreSwatches );
		}

		return;
	}

	viewMoreSwatches( event ) {
		const target = event.target;
		const listParent = target.closest('.view-more-in-list');
		const swatchList = target.closest( '.swatch-list' );

		if ( swatchList != null ) {
			const hiddenRows = swatchList.querySelectorAll( '.swatch-list-item.hidden' );
			for ( let i = 0; i < hiddenRows.length; i++ ) {
				hiddenRows[i].classList.remove('hidden');
			}
		}
		
		if ( listParent != null ) {
			listParent.classList.add( 'hidden' );
		}

		return;
	}

}

customElements.define('product-grid-container', ProductGridContainer)
